import React from 'react';
import PropTypes from 'prop-types';

/**
 * Individual feature option tile (eyebrow style, eye type, etc.)
 */
const FeatureOption = ({ option, isSelected, onClick }) => {
    const imageUrl = option?.image?.reference?.image?.url;
    const title = option?.title?.value || option?.handle || 'Unknown';

    return (
        <button type="button" className={`head-builder-option ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <div className="head-builder-option-image">
                {imageUrl ? (
                    <img src={imageUrl} alt={title} />
                ) : (
                    <div className="head-builder-option-placeholder">No image</div>
                )}
            </div>
            <span className="head-builder-option-title">{title}</span>
        </button>
    );
};

FeatureOption.propTypes = {
    option: PropTypes.shape({
        id: PropTypes.string.isRequired,
        handle: PropTypes.string.isRequired,
        title: PropTypes.shape({
            value: PropTypes.string,
        }),
        image: PropTypes.shape({
            reference: PropTypes.shape({
                image: PropTypes.shape({
                    url: PropTypes.string,
                    altText: PropTypes.string,
                }),
            }),
        }),
    }).isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default FeatureOption;
